import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import { EmMarketProfile } from '@/creditflowresearch/ui/components/profile';
import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import getSSRCorporateTopCompanies
  from '@/creditflowresearch/application/TopCompanies/serverSide/getSSRCorporateTopCompanies';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import getServerSideMarketsBreadcrumbs
  from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideMarketsBreadcrumbs';
import ParentPageContextProvider from '@/creditflowresearch/application/ParentPageContext';
import getServerSideArticlesTile
  from '@/creditflowresearch/application/ArticlesAndStats/Articles/ArticlesTile/serverSide/getServerSideArticlesTile';
import getServerSideStatsTile
  from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsTile/serverSide/getServerSideStatsTile';
import { getProducts } from '@/creditflowresearch/application/Deal/helpers';
import getServerSideMarketPageCorporateDeals
  from '@/creditflowresearch/application/Deal/serverSide/getServerSideMarketPageCorporateDeals';
import getServerSideCorporateMarketChartData
  from '@/creditflowresearch/application/MarketChart/serverSide/getServerSideCorporateMarketChartData';
import { UNDERWRITER_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import { featureToggleServerSide } from '@framework/ui/Organisms/FeatureToggle/Components';
import { HIDE_TOP_COMPANIES } from '@creditflowresearch/config/featureToggle';
import { initialTopCompanies } from '@/creditflowresearch/application/TopCompanies/constants';
import { withQueryValidation, emValidators, getEmPreferenceDefaults } from '@/creditflowresearch/application/helpers/validators';
import URL from '@/creditflowresearch/Router/urlConstants';
import getServerSideRoadshows from '@/creditflowresearch/application/Roadshows/serverSide/getServerSideRoadshows';

export const getServerSideProps = withApplicationPropsV2(
  withQueryValidation(
    {
      defaults: getEmPreferenceDefaults,
      validators: emValidators,
      redirectUrl: URL.MARKET_OVERVIEW_EM,
    },
    async (context) => {
  const { availableProductIds, activeProductId } = getProducts(context);

  const [
    articlesTilesData,
    deals,
    chartData,
    topParents,
    breadcrumbs,
    roadshowsTileData,
    statsTileData,
  ] = await Promise.all([
    getServerSideArticlesTile(context, { deal: null }),
    getServerSideMarketPageCorporateDeals(context),
    getServerSideCorporateMarketChartData(context),
    featureToggleServerSide(context, {
      featureName: HIDE_TOP_COMPANIES,
      featureCallback: getSSRCorporateTopCompanies,
      featureCallbackParams: { checkProductAccess: false, defaultIncludedRole: UNDERWRITER_NAME },
      defaultCallback: async () => initialTopCompanies,
    }),
    getServerSideMarketsBreadcrumbs(),
    getServerSideRoadshows(context, { isTile: true }),
    getServerSideStatsTile(context),
  ]);

  return ({
    props: {
      breadcrumbs,
      topParents,
      deals,
      chartData,
      articlesTilesData,
      availableProductIds,
      activeProductId,
      roadshowsTileData,
      statsTileData,
    },
  });
  },
  ),
  {
    dictionaries: ['countries', 'sizeDescriptions', 'dealStatuses', 'currencies', 'rankings', 'ratings'],
    needsLegacyDictionaries: false,
  },
);

const EmMarket = (props) => (
  <PageFiltersContextProvider profileType={ ProfileTypes.OVERVIEW }>
    <ParentPageContextProvider parentProps={ {
      topParents: props?.topParents,
      deals: props?.deals,
      chartData: props?.chartData,
      articlesTilesData: props?.articlesTilesData,
      availableProductIds: props?.availableProductIds,
      activeProductId: props?.activeProductId,
      roadshowsTileData: props?.roadshowsTileData,
      statsTileData: props?.statsTileData,
    } }
    >
      <PageContentLayout>
        <EmMarketProfile />
      </PageContentLayout>
    </ParentPageContextProvider>
  </PageFiltersContextProvider>
);

export default EmMarket;
